import React from "react";
import AboutHero from "./AboutHero";
import AboutValues from "./AboutValues";
import AboutNumbers from "./AboutNumbers";
import AboutTeam from "./AboutTeam";
import ContactCta from "../main_page/ContactCta";
import Footer from "../Footer";
import TrustedStatsCard from "../main_page/TrustedStatsCard";

import Reveal from "../../components/Reveal"; // ⬅️ додано

export default function AboutPage() {
  return (
    <div className="about-page">
      <Reveal as="section" variant="fade" duration={0.8} threshold={0.15}>
        <AboutHero />
      </Reveal>

      {/* Легкі reveal-ефекти для секцій нижче */}
      <Reveal as="section" variant="up">
        <AboutValues />
      </Reveal>

      {/* <Reveal as="section" variant="up" delay={0.06}>
        <AboutNumbers />
      </Reveal> */}

      <Reveal as="section" variant="fade" duration={0.8} threshold={0.15}>
        <TrustedStatsCard />
      </Reveal>

      <Reveal as="section" variant="fade" delay={0.12} duration={0.9}>
        <AboutTeam />
      </Reveal>

      <Reveal as="section" variant="fade" delay={0.06}>
        <ContactCta />
      </Reveal>

      <Reveal as="footer" variant="fade" delay={0.1}>
        <Footer />
      </Reveal>
    </div>
  );
}
